/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Station_Data_FreshInputs */

const vi_station_data_fresh = /** @type {(inputs: Station_Data_FreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danh sách đơn đã cập nhật`)
};

/**

* @param {Station_Data_FreshInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_data_fresh = /** @type {((inputs?: Station_Data_FreshInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Data_FreshInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_data_fresh(inputs)
});